/* Aurabloom product section: gallery thumbnails, bundle (variant) cards, subscribe toggle. */
(() => {
  class AbProduct {
    constructor(root) {
      this.root = root;
      const data = root.querySelector('[data-nc-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.sub = root.querySelector('[data-nc-sub]');
      this.planInput = root.querySelector('[data-nc-plan]');
      this.atc = root.querySelector('[data-nc-atc]');
      this.form = root.querySelector('form[action*="/cart/add"]');
      if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event));

      root.querySelectorAll('[data-nc-thumb]').forEach((btn) => {
        btn.addEventListener('click', () => this.showMedia(btn.dataset.ncThumb));
      });
      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-nc-variant-radio]')) this.update(true);
        if (event.target === this.sub) this.update(false);
      });
      this.update(false);
    }

    /* Adds to cart in place and opens the theme's cart drawer (Dawn's cart-drawer or
       cart-notification). Without one, the form submits normally to the cart page. */
    async onSubmit(event) {
      const cart = document.querySelector('cart-drawer, cart-notification');
      if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') return;
      event.preventDefault();
      if (!this.atc || this.atc.disabled) return;

      this.showError('');
      this.atc.disabled = true;
      this.atc.setAttribute('aria-busy', 'true');

      const formData = new FormData(this.form);
      formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        });
        const data = await response.json();
        if (data.status) {
          this.showError(data.description || data.message || 'Could not add to cart.');
          return;
        }
        cart.renderContents(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // Dawn declares these as top-level globals, not window properties.
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: data,
          });
        }
      } catch (error) {
        this.form.submit();
      } finally {
        this.atc.removeAttribute('aria-busy');
        this.update(false);
      }
    }

    showError(message) {
      let el = this.root.querySelector('[data-nc-error]');
      if (!el && message && this.atc) {
        el = document.createElement('p');
        el.className = 'nc-buy__error';
        el.setAttribute('role', 'alert');
        el.dataset.ncError = '';
        this.atc.insertAdjacentElement('afterend', el);
      }
      if (!el) return;
      el.textContent = message;
      el.hidden = !message;
    }

    currentVariant() {
      const checked = this.root.querySelector('[data-nc-variant-radio]:checked');
      const hidden = this.root.querySelector('[data-nc-variant-id]');
      const id = Number(checked ? checked.value : hidden && hidden.value);
      return this.variants.find((v) => v.id === id) || this.variants[0];
    }

    showMedia(mediaId) {
      const slide = this.root.querySelector(`[data-nc-slide="${mediaId}"]`);
      if (!slide) return;
      this.root.querySelectorAll('[data-nc-slide]').forEach((el) => el.classList.toggle('is-active', el === slide));
      this.root.querySelectorAll('[data-nc-thumb]').forEach((el) => {
        el.setAttribute('aria-current', el.dataset.ncThumb === String(mediaId) ? 'true' : 'false');
      });
    }

    setAll(selector, fn) {
      this.root.querySelectorAll(selector).forEach(fn);
    }

    update(variantChanged) {
      const v = this.currentVariant();
      if (!v) return;
      const subscribed = Boolean(this.sub && this.sub.checked && v.plan);

      if (this.planInput) {
        this.planInput.value = subscribed ? v.plan : '';
        this.planInput.disabled = !subscribed;
      }

      const price = subscribed && v.sub ? v.sub : v.price;
      this.setAll('[data-nc-price]', (el) => { el.textContent = price; });
      this.setAll('[data-nc-compare]', (el) => {
        el.textContent = v.compare || '';
        el.hidden = !v.compare;
      });
      this.setAll('[data-nc-save]', (el) => {
        el.textContent = (el.dataset.template || 'Save [percent]%').replace('[percent]', v.save);
        el.hidden = !v.save;
      });

      if (this.atc) {
        this.atc.disabled = !v.available;
        const label = this.atc.querySelector('[data-nc-atc-label]');
        if (label) label.textContent = v.available ? this.atc.dataset.addLabel : this.atc.dataset.soldLabel;
      }

      if (variantChanged) {
        if (v.media) this.showMedia(v.media);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  const init = (scope) => {
    scope.querySelectorAll('[data-nc-product]').forEach((el) => {
      if (el.dataset.ncReady) return;
      el.dataset.ncReady = 'true';
      new AbProduct(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
